import { useState } from "react";
import { Users2 } from "lucide-react";
import { toast } from "sonner";
import { API } from "@/lib/api";

export default function TeamCardButton({ match }) {
  const [busy, setBusy] = useState(false);
  const isOff = match.match_type === "official";
  const hasLineup = isOff
    ? (match.availabilities || []).some((a) => a.status === "available")
    : (match.rosters || []).length > 0;

  const fetchCard = async () => {
    const res = await fetch(`${API}/matches/${match.id}/team-card.png`, {
      credentials: "include",
    });
    if (!res.ok) throw new Error("échec");
    return res.blob();
  };

  const download = async () => {
    setBusy(true);
    try {
      const blob = await fetchCard();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `equipe-${match.id}.png`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
      toast.success("Composition téléchargée");
    } catch (e) {
      toast.error("Erreur de génération");
    } finally {
      setBusy(false);
    }
  };

  const share = async () => {
    setBusy(true);
    try {
      const blob = await fetchCard();
      const file = new File([blob], "equipe.png", { type: "image/png" });
      const data = {
        title: "ASS les Régionnaires",
        text: `Composition ${match.title || (isOff ? "vs " + (match.opponent_name || "adversaire") : "Bleus vs Rouges")}`,
        files: [file],
      };
      if (navigator.canShare && navigator.canShare(data)) {
        await navigator.share(data);
      } else {
        await download();
      }
    } catch (e) {
      // user cancelled
    } finally {
      setBusy(false);
    }
  };

  if (!hasLineup) return null;
  return (
    <button
      data-testid="team-card-button"
      type="button"
      onClick={share}
      disabled={busy}
      title="Partager la composition d'équipe"
      className="inline-flex items-center gap-2 px-4 py-2.5 bg-[#E5B85C] hover:bg-[#D4A24E] text-[#0B0F17] font-bold uppercase tracking-wide rounded-lg text-sm disabled:opacity-60"
    >
      <Users2 className="w-4 h-4" />
      {busy ? "..." : "Photo équipe"}
    </button>
  );
}
